export default __webpack_public_path__ + "static/media/sort.fcb1a9ce.jpg";